<template>
  <div>
    <div class="breadcrumb-area pos-relative w-100">
      <h1>Danh sách thiết bị</h1>
      <div>
        <b-button @click="exportExcel" variant="primary" data-toggle="tooltip" data-placement="top">
          <i class="bx bx-download"></i><span>&nbsp;</span>
          {{ showLoading ? "Đang xuất..." : "Xuất Excel" }}
        </b-button>
      </div>
    </div>
    <div class="pt-15 b-t-1-869fb229">
      <FilterDeviceForm @change="handleFilter" />
      <div class="card-body">
        <div class="tab-content" id="nav-tabContent">
          <div class="p-10">
            <div class="mb-2 total-label">Tổng: <span class="text-primary">{{ pagination.total | formatNumberVN
                }}</span>
            </div>
            <b-table :busy.sync="tbLoading" sticky-header hover responsive :items="list" :fields="tableFields"
              :fixed="true" :bordered="true">
              <template #table-busy>
                <div class="my-2 text-center">
                  <b-spinner class="align-middle"></b-spinner>
                </div>
              </template>
              <template #cell(index)="data">
                {{ getIndex(data.index) }}
              </template>

              <template #cell(handoverSendTime)="data">
                <p v-if="data.item.handoverSendTime">
                  {{
                    data.item.handoverSendTime | formatDate("HH:mm, DD/MM/YYYY")
                  }}
                </p>
              </template>
              <template #cell(deliveryTime)="data">
                <p v-if="data.item.deliveryTime">
                  {{
                    data.item.deliveryTime | formatDate("DD/MM/YYYY")
                  }}
                </p>
              </template>
              <template #cell(shippingStatus)="data">
                <b-badge v-show="data.item.shippingStatus" :variant="mapVariantShippingStatus[data.item.shippingStatus]">
                  {{ mapTextShippingStatus[data.item.shippingStatus] }}
                </b-badge>
              </template>
              <template #cell(status)="data">
                <span class="badge" :class="transformDataColor(data.item.status, optionStatus)">
                  {{ data.item.status | transformData(optionStatus) }}
                </span>
              </template>

              <template #cell(action)="{ item }">
                <b-dropdown variant="outline-primary">
                  <b-dropdown-item @click="viewDetails(item.id)">
                    Chi tiết
                  </b-dropdown-item>
                  <b-dropdown-item v-if="dataUser &&
                    dataUser.permissionCodes?.includes('CNPS_DEVICE_AGENT_BANK_UPDATE_INVITE_CODE')
                  " @click="openUpdateInviteCodeModal(item)">
                    Cập nhật mã giới thiệu
                  </b-dropdown-item>
                </b-dropdown>

              </template>
            </b-table>
          </div>
        </div>
      </div>
      <div class="pagination-bottom">
        <b-form-group class="mb-0" style="padding: 17px">
          <b-form-select
            v-model="search.limit"
            :options="pageOptions"
            @change="onItemsPerPageChange"
          ></b-form-select>
        </b-form-group>
        <b-pagination v-model="search.page" :total-rows="pagination.total" :per-page="search.limit"
          @change="handleChangePage"
          class="mr-2 fl-right"></b-pagination>
      </div>
    </div>
    <!-- Modal cập nhật mã giới thiệu -->
    <b-modal id="updateInviteCodeModal" v-model="showUpdateModal" title="Cập nhật mã giới thiệu" @ok="updateInviteCode"
      @cancel="closeUpdateModal" ok-title="Cập nhật" cancel-title="Hủy" :ok-disabled="updateInviteCodeLoading">
      <div v-if="selectedDevice">
        <div class="form-group">
          <label>Thiết bị:</label>
          <p class="font-weight-bold">{{ selectedDevice.categoryName }} - {{ selectedDevice.serial }}</p>
        </div>

        <div class="form-group">
          <label>Mã giới thiệu cũ:</label>
          <p class="text-muted">{{ selectedDevice.inviteCode || 'Chưa có mã giới thiệu' }}</p>
        </div>

        <div class="form-group">
          <label for="newInviteCode">Mã giới thiệu mới: <span class="text-danger">*</span></label>
          <input id="newInviteCode" type="text" v-model="newInviteCode" class="form-control"
            placeholder="Nhập mã giới thiệu mới" :disabled="updateInviteCodeLoading" />
        </div>
      </div>

      <template #modal-footer="{ ok, cancel }">
        <button type="button" class="btn btn-secondary" @click="cancel()" :disabled="updateInviteCodeLoading">
          Hủy
        </button>
        <button type="button" class="btn btn-primary" @click="ok()"
          :disabled="updateInviteCodeLoading || !newInviteCode.trim()">
          <span v-if="updateInviteCodeLoading" class="spinner-border spinner-border-sm mr-2"></span>
          {{ updateInviteCodeLoading ? 'Đang cập nhật...' : 'Cập nhật' }}
        </button>
      </template>
    </b-modal>
    <VueLoadingOverlay :active.sync="showLoading" :is-full-page="true">
    </VueLoadingOverlay>
  </div>
</template>

<script>
import { DeviceService } from '@/services/device.service'
import Config from '@/thirdParty/config'
import FilterDeviceForm from './components/FilterDeviceForm.vue'
import { showMessErrorResponse, showMessError } from '@/config/utils'
import cloneDeep from 'lodash/cloneDeep'

const tableFields = [
  { key: 'index', label: 'STT', class: 'text-center', thStyle: { width: '80px' }, tdStyle: { width: '80px' } },
  { key: 'categoryName', label: 'Tên thiết bị' },
  { key: 'serial', label: 'Mã thiết bị' },
  { key: 'inventoryName', label: 'Kho' },
  { key: 'deliveryTime', label: 'Thời gian giao hàng' },
  { key: 'shippingStatus', label: 'Trạng thái giao hàng' },
  { key: 'status', label: 'Trạng thái kích hoạt' },
  { key: 'handoverSendTime', label: 'Thời gian kích hoạt' },
  { key: 'inviteCode', label: 'Mã giới thiệu' },
  { key: 'action', label: 'Thao tác', fixIndex: 999, class: 'text-center' }
]
const pageOptions = [
  { value: 50, text: '50/trang' },
  { value: 100, text: '100/trang' },
  { value: 200, text: '200/trang' }
]
const searchFieldDefault = Object.freeze({
  page: 1,
  limit: 50
})
export default {
  name: 'DeviceList',
  components: { FilterDeviceForm },
  data () {
    return {
      showUpdateModal: false,
      selectedDevice: null,
      newInviteCode: '',
      updateInviteCodeLoading: false,
      tbLoading: false,
      showLoading: false,
      tableFields,
      optionType: [],
      optionInventory: [],
      optionStatus: [
        { id: '0', text: 'Tất cả', variant: '' },
        ...Config.statusDevices
      ],
      list: [],
      search: cloneDeep(searchFieldDefault),
      dateRange: {
        startDate: null,
        endDate: null
      },
      localeData: Config.localeData,
      pagination: {
        total: 0
      },
      partnerCodeMap: [],
      dataUser: JSON.parse(localStorage.getItem('userData')),
      pageOptions,
      Config
    }
  },
  computed: {
    mapTextShippingStatus () {
      return Config.optionsShippingStatus.reduce((acc, item) => {
        acc[item.id] = item.text
        return acc
      }, {})
    },
    mapVariantShippingStatus () {
      return Config.optionsShippingStatus.reduce((acc, item) => {
        acc[item.id] = item.variant
        return acc
      }, {})
    }
  },

  filters: {
    transformData (data, dataConfig) {
      const dataReturn = dataConfig.filter((e) => e.id === data)
      if (dataReturn.length === 0) {
        return ''
      }
      return dataReturn[0].text
    }
  },

  mounted () {
    this.fetchData()
  },

  methods: {
    async handleFilter (payload) {
      this.search = { ...searchFieldDefault, ...payload }
      await this.fetchData()
    },
    async handleChangePage (page) {
      this.search.page = page
      await this.fetchData()
    },
    async onItemsPerPageChange () {
      this.search.page = 1
      await this.fetchData()
    },
    openUpdateInviteCodeModal (device) {
      this.selectedDevice = device
      this.newInviteCode = device.inviteCode || ''
      this.showUpdateModal = true
    },

    closeUpdateModal () {
      this.showUpdateModal = false
      this.selectedDevice = null
      this.newInviteCode = ''
      this.updateInviteCodeLoading = false
    },
    async updateInviteCode () {
      if (!this.newInviteCode.trim()) {
        this.showFailMx('Vui lòng nhập mã giới thiệu mới')
        return
      }

      try {
        this.updateInviteCodeLoading = true

        // Gọi API cập nhật mã giới thiệu
        const response = await DeviceService.updateInviteCode({
          serials: [this.selectedDevice?.serial],
          inviteCode: this.newInviteCode.trim()
        })

        if (response.code === 1000) {
          this.showSuccessMx(
            'Cập nhật mã giới thiệu thành công'
          )

          // Cập nhật lại danh sách
          await this.fetchData()

          // Đóng modal
          this.closeUpdateModal()
        } else {
          showMessError(this, response.message ?? 'Có lỗi xảy ra khi cập nhật mã giới thiệu')
        }
      } catch (error) {
        showMessErrorResponse(this, error)
      } finally {
        this.updateInviteCodeLoading = false
      }
    },

    transformDataColor (data, dataConfig) {
      const dataReturn = dataConfig.filter((e) => e.id === data)
      if (dataReturn.length === 0) {
        return ''
      }
      return dataReturn[0].bgColor
    },

    viewDetails (id) {
      this.$router.push(`/list-device/detail/${id}`)
    },

    updateDevice (id) {
      this.$router.push(`/devices/update/${id}`)
    },

    formatDateTime (dateString) {
      if (!dateString) return 'N/A'
      const date = new Date(dateString)
      const hours = String(date.getHours()).padStart(2, '0')
      const minutes = String(date.getMinutes()).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const year = date.getFullYear()

      return `${hours}:${minutes}, ${day}/${month}/${year}`
    },

    getStatusLabel (status) {
      const statusOption = this.optionStatus.find(
        (option) => option.id === status
      )
      return statusOption ? statusOption.text : status
    },

    getStatusClass (status) {
      const statusOption = this.optionStatus.find(
        (option) => option.id === status
      )
      return statusOption ? `text-${statusOption.variant}` : ''
    },

    async exportExcel () {
      try {
        this.showLoading = true
        for (const key in this.search) {
          if (this.search[key] === '0') delete this.search[key]
        }
        // const req = {
        //   ...this.search,
        //   ...(this.search.inventoryIds && {
        //     inventoryIds: this.search.inventoryIds
        //   })
        // }
        // delete req.limit
        // delete req.page
        const { limit, page, ...body } = this.search
        await DeviceService.downloadFileExcel(body)
      } catch (error) {
        this.showFailMx(`Lỗi: ${error.message}`)
      } finally {
        this.showLoading = false
      }
    },

    async fetchData () {
      try {
        this.tbLoading = true
        const params = { ...this.search }
        const response = await DeviceService.ListDevice(params)
        if (response.code === 1000) {
          this.list = response.data.devices || []
          this.pagination.total = response?.data?.count || 0
        } else {
          showMessError(this, response.message)
        }
      } catch (error) {
        showMessErrorResponse(this, error)
      } finally {
        this.tbLoading = false
      }
    }
  }
}
</script>

<style scoped>
.breadcrumb-area {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.box-search {
  display: flex;
  flex-wrap: wrap;
}

.form-group {
  margin-bottom: 10px;
  min-width: 200px;
}

.form-group-action {
  display: flex;
  align-items: flex-end;
}

.pagination-bottom {
  display: flex;
  justify-content: flex-end;
  margin-right: 10px;
}
</style>
